/** @deprecated Use BusinessFunctionsScreen. Kept for deep links. */
import { DeprecatedSettingsRedirectScreen } from './DeprecatedSettingsRedirectScreen';

export const OperationModeScreen = () => (
  <DeprecatedSettingsRedirectScreen target="BusinessFunctions" />
);
